<template lang="pug">
    div.pl-md-5.pr-md-5(style='display: flex; justify-content: flex-end; align-items: center; flex-grow: 1;')
        v-menu.text-right.help-menu(bottom left :min-width='minWidth' max-width='450px' max-height='600px' offset-y)
            template(v-slot:activator='{ on, attrs }')
                v-btn(icon v-on='on')
                    v-icon(:color="iconColor") mdi-help-circle-outline
            v-subheader.font-weight-bold(style="background-color: var(--white);" v-if="!excludeTitle")
                | {{ title }}
            v-list(dense three-line)
                template(v-for='(item, i) in helpDefinitions')
                    v-divider(v-if='item.sectionHeading && i > 0' :key='"divider-" + i')
                    v-subheader.font-weight-bold(v-if='item.sectionHeading' :key='"heading-" + i' style='height: 32px;' :class='colorClass')
                        | {{ item.title }}
                    v-list-item(v-else :key='"item-" + i' class='help-list-item')
                        v-list-item-content
                            v-list-item-title.font-weight-bold(:class='colorClass')
                                | {{ item.title }}
                            v-list-item-subtitle.v-list-item-subtitle(v-html="item.description")

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            colorClass() {
                if (this.textColorClass?.length > 0) {
                    return this.textColorClass;
                }

                return 'volie-color-blue';
            },
        },
        props: {
            iconColor: {
                type: String,
                default: undefined,
            },
            textColorClass: String,
            helpDefinitions: Array,
            title: {
                type: String,
                default: 'Definitions' // Default title
            },
            excludeTitle: Boolean, 
            minWidth: {
                type: String,
                default: '450px',
            },
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .help-menu {
            z-index: 100;
        }

        .help-list-item {
            min-height: 25px !important;
        }

        .v-list-item-subtitle {
            display: block; /* Ensures subtitle is displayed in full */
            white-space: normal; /* Allows the text to wrap */
            overflow: visible; /* Ensures the content doesn't get clipped */
            text-overflow: unset; /* Removes the ellipsis */
        }
    }
</style>